var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.94626 2.60745H11.2037L10.5955 1.08749C10.4662 0.763142 10.5608 0.39227 10.828 0.173128C11.0955 -0.0458716 11.4719 -0.0580185 11.7533 0.141908L16.6674 3.63188C16.8827 3.78474 17.0077 4.0388 16.9996 4.30653C16.9916 4.57408 16.8516 4.81961 16.6276 4.95859L11.4891 8.14886C11.1968 8.33028 10.8229 8.29423 10.5693 8.0601C10.3153 7.82601 10.2418 7.44523 10.388 7.12948L11.0634 5.66858H3.94626C3.42107 5.66858 2.99384 6.11383 2.99384 6.65078V11.9731C2.99384 12.5101 3.42107 12.9388 3.94626 12.9388H11.8225C12.5251 12.9388 13.0947 13.5212 13.0947 14.2396V14.6992C13.0947 15.4177 12.5251 16 11.8225 16H3.94626C1.77026 16 0 14.1981 0 11.9731V6.65081C-7.05719e-05 4.42576 1.77026 2.60745 3.94626 2.60745Z",
    fill: "#636363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackRight);
export default __webpack_public_path__ + "static/media/BackRight.a1f1dce1a29cabd2a0402fa90f956da0.svg";
export { ForwardRef as ReactComponent };